import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react-components';

import {
  Collapse,
  useCollapseState,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { RemainingCharsValidatedTextField } from '@bingads-webui-campaign-react/remaining-chars-hint';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { andComp, entityIs, propertyIs } from '@bingads-webui-campaign-react/form-error';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { ValidatedFormCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { buildLegacyI18n } from '@bingads-webui/build-legacy-i18n';
import { ValidationStringMap } from '@bingads-webui/validation-string-map';

import TextAssetsImg from '../media/text-icon.svg';

const entityIsAd = entityIs(ERROR_ENTITY.Ad);
const DescriptionProp = andComp(entityIsAd, propertyIs('ResponsiveAdDescriptions'));
const ServerValidatedTextField = withControlErrorHandling(withUnvalidatedControlErrors(RemainingCharsValidatedTextField, { filter: DescriptionProp }));

export const CollapsibleIntroductoryText = ({
  schema,
}) => {
  const i18n = useContext(I18nContext);
  const legacyI18n = useMemo(() => buildLegacyI18n(i18n, [ValidationStringMap]), [i18n]);

  const [
    allSections,
    expandedSections,
    setExpandedSections,
  ] = useCollapseState(['introductory-text'], ['introductory-text']);

  return (
    <div className="introductory-text-section">
      <Collapse
        allPanelItems={allSections}
        checkItems
        skipItemsTypeCheck
        activeKeys={expandedSections}
        setActiveKeys={setExpandedSections}
      >
        <ValidatedFormCard
          key="introductory-text"
          className="introductory-text-card"
          attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
        >
          <FormCardBasicHeader
            title={i18n.getString(_TL_('Introductory text'))}
            helpTopic="pop_BA_LinkedIn_IntroductoryText"
            helpLabel={i18n.getString(_TL_('Click to learn more about introductory text'))}
            contentBefore={<Image src={TextAssetsImg} aria-hidden />}
          />
          <FormCardBody>
            <ServerValidatedTextField
              multiline
              placeholder={i18n.getString(_TL_('Enter your introductory text'))}
              id="input-introductory-text"
              validationProps={{
                field: 'Descriptions/Description0',
                schema,
                i18n: legacyI18n,
              }}
              i18n={i18n}
            />
          </FormCardBody>
        </ValidatedFormCard>
      </Collapse>
    </div>
  );
};

CollapsibleIntroductoryText.propTypes = {
  schema: PropTypes.shape({}).isRequired,
};
